import React from 'react';
import { Navigation } from '../components/Navigation';
import { HeroVariant82 } from '../components/HeroVariant82';
import { About } from '../components/About';
import { Services } from '../components/Services';
import { WhyUs } from '../components/WhyUs';
import { Stats } from '../components/Stats';
import { Testimonials } from '../components/Testimonials';
import { FAQ } from '../components/FAQ';
import { Consultation } from '../components/Consultation';
import { Footer } from '../components/Footer';
import { CookieBanner } from '../components/CookieBanner';
import { FloatingContact } from '../components/FloatingContact';
export function LandingPage82() {
  return <div className="min-h-screen bg-[var(--bg-primary)] text-[var(--text-primary)] transition-colors duration-300" data-id="element-1848">
      <Navigation data-id="element-1849" />
      <main data-id="element-1850">
        <HeroVariant82 data-id="element-1851" />
        <About data-id="element-1852" />
        <Services data-id="element-1853" />
        <WhyUs data-id="element-1854" />
        <Stats data-id="element-1855" />
        <Testimonials data-id="element-1856" />
        <FAQ data-id="element-1857" />
        <Consultation data-id="element-1858" />
      </main>
      <Footer data-id="element-1859" />
      <CookieBanner data-id="element-1860" />
      <FloatingContact data-id="element-1861" />
    </div>;
}